import { Shimmer } from "../dashboard/skeleton";

/**
 * Loading placeholder for the chase table.
 *
 * Mirrors the real row's eight columns and their alignment, so nothing shifts when
 * the data lands. Uses the same travelling shimmer as the rest of the app rather
 * than a pulsing block.
 */
const SkeltonTableRow = () => {
  return (
    <>
      {Array.from(Array(8)).map((_, index) => (
        <tr className="border-b border-edge-faint" key={index}>
          <td className="py-4 pr-4">
            <Shimmer className="h-4 w-[150px] rounded-full" />
            <Shimmer className="h-3 w-[90px] rounded-full mt-2" />
          </td>
          <td className="py-4 pr-4">
            <Shimmer className="h-3 w-[180px] rounded-full" />
            <Shimmer className="h-3 w-[110px] rounded-full mt-2" />
          </td>
          <td className="py-4 pr-4">
            <Shimmer className="h-3 w-[100px] rounded-full" />
            <Shimmer className="h-3 w-[110px] rounded-full mt-2" />
          </td>
          <td className="py-4 pr-4">
            <div className="flex justify-end">
              <Shimmer className="h-4 w-[70px] rounded-full" />
            </div>
          </td>
          <td className="py-4 pr-4">
            <div className="flex justify-end">
              <Shimmer className="h-4 w-[70px] rounded-full" />
            </div>
          </td>
          <td className="py-4 pr-4">
            <div className="flex justify-center">
              <Shimmer className="h-4 w-[60px] rounded-full" />
            </div>
          </td>
          <td className="py-4 pr-4">
            <Shimmer className="h-6 w-[96px] rounded-full" />
          </td>
          <td className="py-4">
            <div className="flex justify-end gap-1.5">
              <Shimmer className="h-8 w-8 rounded-full" />
              <Shimmer className="h-8 w-8 rounded-full" />
              <Shimmer className="h-8 w-8 rounded-full" />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default SkeltonTableRow;
